module.exports = __webpack_public_path__ + "img/wz-8-7-4.07f26666.jpg";